import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mobile-menu" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "close" }
const _hoisted_5 = { class: "menu" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "separator"
}

import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { svgIcon } from "@/common/components";

interface MenuListType {
  icon: string;
  label?: string;
  url?: string;
  key: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'mobile-menu',
  props: {
    menuList: {},
    active: {},
    height: { default: "4rem" },
    background: { default: "#fff" },
    iconSize: { default: "1.75rem" }
  },
  emits: ["open", "close"],
  setup(__props: any, { emit: __emit }) {

const router = useRouter();



const emit = __emit;

const show = ref(false);

function open(menu: MenuListType) {
  if (menu.url) {
    router.push(menu.url);
    return;
  }

  emit("open", menu);
}

function close() {
  show.value = false;
  setTimeout(() => {
    emit("close");
  }, 150);
}

onMounted(() => {
  setTimeout(() => {
    show.value = true;
  }, 150);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_Transition, { name: "fade-left" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-none",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (close()))
              }, [
                _createVNode(_unref(svgIcon), {
                  icon: "close",
                  size: "1.5rem"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menuList, (menu, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: menu.key
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["item", {
                active: __props.active === menu.key,
              }]),
                  onClick: ($event: any) => (open(menu))
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_unref(svgIcon), {
                      icon: menu.icon,
                      size: __props.iconSize
                    }, null, 8, ["icon", "size"])
                  ]),
                  (menu.label)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(menu.label), 1))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_6),
                ((index + 1) < __props.menuList?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ], 512), [
          [_vShow, show.value]
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: "off",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (close()))
    })
  ]))
}
}

})